// extracted by mini-css-extract-plugin
module.exports = {"picture":"Pictures_picture__2PiLn"};